import { Product } from '../../../../types/catalog';
import { Link } from 'react-router-dom';
import { selectImage } from '../../../../util/misc';

function AnalogList({ analogs }: { analogs: Product[] }) {
    return (
        <div className="iek-prodcat-catalog-detail-analog">
            {analogs.map(({ url, name, imageUrl, imageVariants }) => {
                const imgUrl = selectImage(imageVariants, 300, 100, imageUrl);
                return (
                    <Link to={url} className="iek-prodcat-catalog-detail-analog-item">
                        <div className="iek-prodcat-catalog-detail-analog-item__image-wrap">
                            {imgUrl && <img alt={name} title={name} src={imgUrl} />}
                        </div>

                        <div className="iek-prodcat-catalog-detail-analog-item__name">{name}</div>
                    </Link>
                );
            })}
        </div>
    );
}

export default AnalogList;
